import React from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

import tabLogo from "./assets/images/tabLogo.png";
import tabLogoInactive from "./assets/images/tabLogoInactive.png";

const TabLink = props => {
  function renderBadgeCount() {
    if (props.count > 0) {
      return <span className="badge-count">{props.count}</span>;
    }
    return null;
  }

  function renderIconAndLabel() {
    if (props.root) {
      const tabLogoImage = props.isRootActive ? tabLogo : tabLogoInactive;

      return (
        <span className="icon-root-wrap">
          <img src={tabLogoImage} alt={props.title} />
        </span>
      );
    }

    return (
      <span className="icon-wrap">
        {renderBadgeCount()}
        <i className={props.icon} />
        <span>{props.title}</span>
      </span>
    );
  }

  const checkAdditonalConditions = (match, location) => {
    if (!match) {
      return false;
    }

    if (props.root) {
      const rootRoutes = [
        "/",
        "/regions",
        "/sport-types",
        "/sport-variants",
        "/parameters",
        "/results"
      ];

      if (rootRoutes.indexOf(location.pathname) !== -1) {
        return true;
      }
    }

    return true;
  };

  return (
    <NavLink
      exact={true}
      to={props.link}
      className={classNames("tab", props.root ? "tab-root" : "")}
      activeClassName="active"
      isActive={checkAdditonalConditions}
    >
      {renderIconAndLabel()}
    </NavLink>
  );
};

TabLink.propTypes = {
  root: PropTypes.bool,
  isRootActive: PropTypes.bool,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};

TabLink.defaultProps = {
  root: false,
  isRootActive: false
};

const FooterTabLinks = props => {
  const isRootActive = () => {
    const rootRoutes = [
      "/",
      "/regions",
      "/sport-types",
      "/sport-variants",
      "/parameters",
      "/results"
    ];

    if (rootRoutes.indexOf(props.location.pathname) !== -1) {
      return true;
    }

    return false;
  };

  return (
    <React.Fragment>
      <TabLink root isRootActive={isRootActive()} title="HWK Skiwax" link="/" />
      <TabLink title={props.t('weather:screen_title')} icon="icon-weather" link="/weather" />
      <TabLink
        title={props.t('wishlist:screen_title')}
        icon="icon-heart"
        count={props.wishlistCount}
        link="/wishlist"
      />
      <TabLink title={props.t('settings:screen_title')} icon="icon-settings" link="/settings" />
    </React.Fragment>
  );
};

FooterTabLinks.propTypes = {
  wishlistCount: PropTypes.number
};

FooterTabLinks.defaultProps = {
  wishlistCount: 0
};

const mapStateToProps = state => ({
  wishlistCount: state.wishlist.products.length
});

export default connect(
  mapStateToProps,
  null
)(withRouter(withNamespaces(["weather", "wishlist", "settings", "common"], { wait: true })(FooterTabLinks)));
